import { render, staticRenderFns } from "./commercialListItemTree.vue?vue&type=template&id=deda074a&scoped=true"
import script from "./commercialListItemTree.vue?vue&type=script&lang=js"
export * from "./commercialListItemTree.vue?vue&type=script&lang=js"
import style0 from "./commercialListItemTree.vue?vue&type=style&index=0&id=deda074a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deda074a",
  null
  
)

export default component.exports